import { render, staticRenderFns } from "./valid-medicalCus.vue?vue&type=template&id=13c70a57&scoped=true&"
import script from "./valid-medicalCus.vue?vue&type=script&lang=js&"
export * from "./valid-medicalCus.vue?vue&type=script&lang=js&"
import style0 from "./valid-medicalCus.vue?vue&type=style&index=0&id=13c70a57&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13c70a57",
  null
  
)

export default component.exports